// React imports.
import React, { Component } from "react";
//library imports
import Highcharts from 'highcharts';
import exporting from 'highcharts/modules/exporting'; 
import offlineExporting from 'highcharts/modules/offline-exporting';
import HighchartsReact from 'highcharts-react-official';

// App imports.

import { IHighChartsDataseries, formatLabelNumber } from "../utility";
exporting(Highcharts);
offlineExporting(Highcharts);

const ChartPie = ({title, subTitle, dataSeries, xAxisCategoryLabels, formatFunction}) => {

  let legendParamObject = {
        layout: 'vertical'
        , align: 'right'
        , verticalAlign: 'middle'
        //,y: 125
        , floating: false
      }


  let toolTipParamObject = function () {
    return '<b>' + this.key + '</b><br/><span style="color:'
      + this.series.color + '">' + this.series.name + '</span>: '
      + this.point.displayVal + '<br/>';
  };

  const yAxisObjectArray = [{
        labels: {
          formatter: formatFunction,
          style: {
            //color: Highcharts.getOptions().colors[0]
            color: '#000'
          }
        },
        gridLineColor: '#555',
        title: {
          text: ' ',
          style: {
            color: Highcharts.getOptions().colors[0]
          }
        },
        min: 0
      }];


  let options = {
    exporting: {
      buttons: {
          contextButton: {
              menuItems: ['downloadPNG', 'downloadJPEG', 'downloadPDF', 'downloadSVG']
          }
      }
    },
    credits: {
      enabled: false
    },
    chart: {
      type: 'pie',
    },
    title: {
      text: title
    },
    legend: legendParamObject,
    subtitle: {
      text: subTitle
    },
    xAxis: {
      labels: {
        enabled: true,
      },
      categories: xAxisCategoryLabels,
      crosshair: true
    },
    yAxis: yAxisObjectArray,
    series: dataSeries,
    tooltip: {
        formatter: toolTipParamObject,
        shared: false
    },
    plotOptions: {
      series:
      {
        dataLabels: {
          enabled: true,
          formatter: function () {
            return `${this.point.percentage.toFixed(1) } %`;
          },
          style: {
            textShadow: ''
          }
        }
      },
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        showInLegend: true,
        //size:300,
      },
    }
 
  };
  return (
    <HighchartsReact highcharts={Highcharts} options={options} />
  );
}
export default ChartPie;
